import { render, staticRenderFns } from "./FederatedTokenLogin.vue?vue&type=template&id=002063a8"
import script from "./FederatedTokenLogin.vue?vue&type=script&lang=js"
export * from "./FederatedTokenLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports